import { FieldValidationRules } from "../types";

export const restrictedSicCodesForACC = [
  '0811',
  '1099',
  '1221',
  '1222',
  '1231',
  '1241',
  '1311',
  '1321',
  '1381',
  '1382',
  '1389',
  '1761',
  '1799',
  '2411',
  '2421',
  '2426',
  '2429',
  '2819',
  '2892',
  '2899',
  '3482',
  '3483',
  '3484',
  '3489',
  '3731',
  '3732',
  '3743',
  '3799',
  '4011',
  '4013',
  '4111',
  '4119',
  '4121',
  '4131',
  '4141',
  '4142',
  '4173',
  '4212',
  '4213',
  '4214',
  '4215',
  '4221',
  '4222',
  '4225',
  '4226',
  '4231',
  '4412',
  '4424',
  '4432',
  '4449',
  '4481',
  '4482',
  '4489',
  '4491',
  '4492',
  '4493',
  '4499',
  '4512',
  '4513',
  '4522',
  '4612',
  '4613',
  '4619',
  '4789',
  '5169',
  '5541',
  '5812',
  '5813',
  '5999',
  '7299',
  '7381',
  '7389',
  '7542',
  '7692',
  '7699',
  '7941',
  '7948',
  '7993',
  '7996',
  '7997',
  '7999',
  '8082',
  '8351',
  '8361',
  '8399',
  '8611',
  '8621',
  '8631',
  '8641',
  '8651',
  '8661',
  '8699',
  '8999',
  '9221',
  '9223',
  '9224',
  '9229',
  '9711',
  '9721',
  '9999',
];

export const ACCValidationRules: Record<string, FieldValidationRules> = {
  'ACCFundingStructure.payrollFrequencyCd': {
    required: true,
    errorMessages: {
      required: "'Payroll Frequency' is mandatory",
    },
  },

};